import React from "react";
import Layout from "../../../../components/site/Layout/Layout";
import type { CalendarEvent } from "@/types/calendarEvent";
import { fetchUpcomingEvents } from "@/utils/googleCalendar";
import EventCard from "./components/EventCard";

const SchedulePage: React.FC = () => {
	const [events, setEvents] = React.useState<CalendarEvent[]>([]);

	React.useEffect(() => {
		fetchUpcomingEvents().then((fetchedEvents) => {
			if (fetchedEvents) {
				setEvents(fetchedEvents);
			}
		});
	}, []);

	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-3xl font-bold text-center mb-8">
					もくもく会スケジュール
				</h1>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					{events.map((event) => (
						<EventCard key={event.id} event={event} />
					))}
				</div>
			</div>
		</Layout>
	);
};

export default SchedulePage;
